import React from 'react'
import { Container, Button, Row, Col, Input } from 'reactstrap';
import * as XLSX from "xlsx";
import 'bootstrap/dist/css/bootstrap.css';

//const testData = require('./TestData.js');

class ImportClientData extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            clientData: {},
            clientId: 0,
            uploadSuccess: false,
            saveSuccess: false
        };

    }

    componentDidMount = () => {
        this.props.log('ImportClientData.js/componentDidMount');
    }

    handleUpload = (e, schema) => {
        this.props.log('ImportClientData.js/handleUpload (e,schema) ', e, schema);
        e.preventDefault();
        var files = e.target.files, f = files[0];
        // console.log(fileId, 'fileId')
        var retObj = {};
        var reader = new FileReader();
        reader.onload = (r) => {
            var result = r.target.result;
            let readedData = XLSX.read(result, { type: 'binary', cellDates: true, sheetStubs: true });
            let tabData = [];
            readedData.SheetNames.forEach(sheet => {
                const ws = readedData.Sheets[sheet];
                /* Convert array to json*/
                let data = XLSX.utils.sheet_to_json(ws, { header: 1 });
                const numColumns = Math.max(...data.map(el => el.length));
                if (data.length === 0) return;
                let trimBlankRowPos = -1;
                data.forEach((row, index, arr) => {
                    let newArr = new Array(numColumns).fill('');
                    const x = newArr.map((el, i) => (row[i] != null) ? row[i].toString() : '');
                    arr[index] = x;
                    if (row.every(cell => cell === '') && trimBlankRowPos === -1) {
                        trimBlankRowPos = index;
                    } else if (!(row.every(cell => cell === ''))) {
                        trimBlankRowPos = -1;
                    }
                })
                if (trimBlankRowPos > -1) data.splice(trimBlankRowPos);
                tabData.push({ tab: sheet, data: data });
            })
            tabData.forEach(tab => {
                tab.data.splice(0, 1);
            })
            // console.log('tabData', tabData)
            retObj = {
                name: tabData[0].data[0][0],
                date: tabData[0].data[0][1],
                securities: tabData[1].data,
                accounts: tabData[2].data,
                reconciliations: tabData[3].data
            }
            // console.log('retObj', retObj);
            this.setState({
                uploadSuccess: false,
                saveSuccess: false,
                clientData: retObj,
                clientId: this.props.clients.findIndex(item => item.client.toUpperCase() === retObj.name.toUpperCase()) > -1 ?
                    this.props.clients[this.props.clients.findIndex(item => item.client.toUpperCase() === retObj.name.toUpperCase())].id : 0
            });
        };
        if (f instanceof Blob || typeof (f) === 'object') {
            reader.readAsBinaryString(f)
        } else {
            this.setState({
                uploadSuccess: false,
                saveSuccess: false,
                clientData: {},
                clientId: 0
            });
        }

    }

    handleSave = () => {
        this.props.log('ImportClientData.js/handleSave');
        const json_request = JSON.stringify({
            clientId: this.state.clientId,
            date: this.state.clientData.date,
            securities: this.state.clientData.securities,
            accounts: this.state.clientData.accounts,
            reconciliations: this.state.clientData.reconciliations
        });
        fetch('/api/clientReports/', {
            method: 'POST',
            body: json_request,
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken
            }
        }).then(results => results.json())
            .then(results => {
                results.success ?
                    this.setState({
                        uploadSuccess: true,
                        saveSuccess: true,
                        clientData: {}
                    }, () => this.props.addToast('Client data imported successfully.', 5, 'success')) :
                    this.setState({
                        uploadSuccess: true,
                        saveSuccess: false,
                        clientData: {}
                    }, () => this.props.addToast('Unable to import client data.', 5, 'danger'))
            })
            .catch(() => {
                this.props.addToast('An error has occurred.', 5, 'danger');
            })
    };

    render = () => {
        this.props.info('ImportClientData.js/render');
        return (
            <>
                <Container>
                    {/* {this.state.uploadSuccess ?
                        <Row><Col md={12}> {(this.state.saveSuccess ?
                            <Alert color="success">Upload successful.</Alert> :
                            <Alert color="danger">Upload unsuccessful.</Alert>)}
                        </Col></Row>
                        : <></>} */}
                    <Row>
                        <Col md={6}>
                            <Row className="p-2">
                                <Col md={12} className="text-left">
                                    <Input type="file" name={"file_"} id="file" accept='.xlsx' onChange={e => this.handleUpload(e)} />
                                </Col>
                            </Row>
                            <Row className="p-2">
                                <Col md={12} className="text-left">
                                    <Button color="success" disabled={Object.keys(this.state.clientData).length === 0 || this.state.clientId === 0} onClick={this.handleSave} title="Upload">Upload</Button>
                                </Col>
                            </Row>
                        </Col>
                        {(Object.keys(this.state.clientData).length > 0) ?
                            <Col md={6}>
                                <Row>
                                    <Col md={4} className="text-right"><strong>Name:</strong></Col>
                                    <Col md={8} className="text-left">{(this.state.clientData.name != null) ? this.state.clientData.name : ''}
                                        {this.state.clientId === 0 ?
                                            <div className="text-left alertMessage">Company not found</div>
                                            : <></>}
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md={4} className="text-right"></Col>
                                </Row>
                                <Row>
                                    <Col md={4} className="text-right"><strong>Date:</strong></Col>
                                    <Col md={8} className="text-left">{(this.state.clientData.date != null) ? this.state.clientData.date.substr(0, 15) : ''}</Col>
                                </Row>
                                <Row>
                                    <Col md={4} className="text-right"><strong>Securities:</strong></Col>
                                    <Col md={8} className="text-left">{(this.state.clientData.securities != null) ? this.state.clientData.securities.length : ''}</Col>
                                </Row>
                                <Row>
                                    <Col md={4} className="text-right"><strong>Accounts:</strong></Col>
                                    <Col md={8} className="text-left">{(this.state.clientData.accounts != null) ? this.state.clientData.accounts.length : ''}</Col>
                                </Row>
                                <Row>
                                    <Col md={4} className="text-right"><strong>Reconciliations:</strong></Col>
                                    <Col md={8} className="text-left">{(this.state.clientData.reconciliations != null) ? this.state.clientData.reconciliations.length : ''}</Col>
                                </Row>
                            </Col> : <></>}
                    </Row>
                </Container>
            </>
        )
    }
}

export default ImportClientData;